import RechargePayInvoicePb from "../protos/RechargePayInvoice.pb";

const pbMap = {
    "/recharge/pay/invoice": RechargePayInvoicePb.Recharge.PayInvoice,
};

function encode(url, data) {
    const { Request } = pbMap[url] || {};
    return Request ? new Request(data) : data;
}
function decode(url, res) {
    const { Response } = pbMap[url] || {};
    return res.code == 1
        ? { code: res.code, data: Response.decode(res.data.value) }
        : res;
}

export { decode, encode };



// WEBPACK FOOTER //
// ./js/service/api/pb.js